import React, { useContext, useState, useEffect } from "react";
import { Card, Row, Col } from "react-bootstrap";
import { Input } from "reactstrap";
import ActionButtons from "../JobControl/ActionButton";
import { AppContext } from "../MainComponents/AppContext";
const Step1 = (props) => {
    const [appContext] = useContext(AppContext);
    const [error, setError] = useState("");
    const [jobName, setJobName] = useState("");
    const [jobDesc, setJobDesc] = useState("");
    const onInputChanged = (event) => {
        const targetName = event.target.name;
        const targetValue = event.target.value;
        setError("");
        if (targetName === "name")
            setJobName(targetValue);
        else
            setJobDesc(targetValue);
    };
    const validate = () => {
        if (!jobName.trim()) setError("Required");
        else {
            setError("");
            appContext.entraJob.name = jobName;
            appContext.entraJob.description = jobDesc;
            props.nextStep();
        }
        props.nextStep();
    };
    useEffect(() => {
        setJobName(appContext.entraJob.name);
        setJobDesc(appContext.entraJob.description);
    }, [appContext.entraJob]);
    return (
        <Card>
            <Card.Header>
                <span id="TitleLabel" className="SectionTitle">Job Detail </span>
            </Card.Header>
            <Card.Body>
                <Row>
                    <Col sm={12 }>
                        <div className="form-group">
                            <span id="Wizard1_lblJobName" className="wizardtext" style={{ fontFamily: "'Poppins', sans-serif", fontWeight: '500', fontSize: 'medium' }}>Name</span>
                            <Input
                                type="text"
                                id="WizardJobname"
                                name="name"
                                placeholder="Enter job name"
                                onChange={onInputChanged}
                                value={jobName}
                            />
                            <span id="WizardRequiredFieldValidatorEntraJobName" style={{ color: "red" }} >{error}</span>
                        </div>
                    </Col>
                    <Col sm={12}>
                        <span id="Wizard1_lblDescription" className="wizardtext" style={{ fontFamily: "'Poppins', sans-serif", fontWeight: '500', fontSize: 'medium' }}>Description</span>
                        <br />
                        <Input type="textarea" rows="4" name="description" id="exampleText" value={jobDesc} onChange={onInputChanged} />
                    </Col>
                </Row>
            </Card.Body>
            <Card.Footer>
                <table cellSpacing="5" cellPadding="5" align="right">
                    <tbody>
                        <tr>
                            <td >
                                <ActionButtons {...props} nextStep={validate} />
                            </td>
                        </tr>
                    </tbody>
                </table>
            </Card.Footer>
        </Card>
    );
}
export default Step1;